export const MIN_BOARD_ZOOM = 0.25;
export const MAX_BOARD_ZOOM = 4;

export function nextWhiteboardZoom(current, deltaY, deltaMode = 0, pageHeight = 800) {
  const pixels = deltaY * (deltaMode === 1 ? 16 : deltaMode === 2 ? pageHeight : 1);
  return Math.min(MAX_BOARD_ZOOM, Math.max(MIN_BOARD_ZOOM,
    current * Math.exp(-Math.max(-240, Math.min(240, pixels)) * 0.0015)));
}
